export default {
    slug: 'ai_assistant',
    settingsRoutes: [
        {
            path: 'ai',
            name: 'settings-ai',
            component: () => import('@modules/Ai/Resources/js/pages/settings/AiSettings.vue'),
            props: true
        }
    ],
    settings: () => [
        {
            title: i18n.t('Administration'),
            order: 30,
            items: [
                {
                    title: i18n.t('AI Assistant'),
                    icon: 'creation',
                    route: 'settings-ai',
                    admin: true,
                    module: 'ai_assistant'
                }
            ]
        }
    ]
};
